// extracted by mini-css-extract-plugin
module.exports = {"container":"QRNXfRzy-8pmTDF5BcQ_Y","code":"_29eyoQp4EU1ix2TptjGPJP","abbr":"_3kwSh6DblKRc4UIycG67WO","stock-type":"_2HGdKa6bFBwYPs5YTUGXRp"};